/** F6 — notificações na tela + preferências de e-mail. */
import { z } from 'zod';
import { Id } from './comum.js';

export const TipoNotificacao = z.enum(['MENCAO', 'ATRIBUIDA', 'REVISAO', 'DEVOLVIDA', 'CLIENTE', 'CAIXA_POSTAL']);
export type TipoNotificacao = z.infer<typeof TipoNotificacao>;

export const Notificacao = z.object({
  id: Id, tipo: TipoNotificacao, tarefaId: Id.nullable(), clienteId: Id.nullable().optional(), titulo: z.string(), texto: z.string(), lidaEm: z.string().nullable(), criadoEm: z.string(),
});
export type Notificacao = z.infer<typeof Notificacao>;

export const NotificacoesResposta = z.object({ itens: z.array(Notificacao), naoLidas: z.number().int(), lidas: z.number().int().optional() });
export type NotificacoesResposta = z.infer<typeof NotificacoesResposta>;

export const NotificacoesLimpas = z.object({ removidas: z.number().int() });
export const NotificacoesLerBody = z.object({ ids: z.array(Id).max(500).optional(), todas: z.boolean().optional() });

export const PreferenciasNotificacao = z.object({ emailMencao: z.boolean(), emailAtribuicao: z.boolean(), emailDigest: z.boolean() });
export type PreferenciasNotificacao = z.infer<typeof PreferenciasNotificacao>;
export const PreferenciasNotificacaoBody = PreferenciasNotificacao.partial();

/** Digest diário (o que o worker manda por e-mail às 7h) — também consultável pela API para conferência. */
export const DigestTarefa = z.object({ id: Id, clienteNome: z.string().nullable(), titulo: z.string(), competenciaLabel: z.string().nullable(), vencimento: z.string(), diasParaVencer: z.number().int(), prazoInterno: z.string().optional(), internoVencido: z.boolean().optional() });
export const Digest = z.object({
  atrasadas: z.array(DigestTarefa), hoje: z.array(DigestTarefa), proximas: z.array(DigestTarefa),
  /** prazo interno vencido com o vencimento real ainda longe (as que vencem em até 3 dias já estão acima, marcadas) */
  internoVencido: z.array(DigestTarefa).optional(),
  totais: z.object({ atrasadas: z.number().int(), hoje: z.number().int(), proximas: z.number().int(), semResponsavel: z.number().int(), internoVencido: z.number().int().optional(),
    /** fatia 2a (do escritório todo): pagamentos que clientes avisaram com comprovante nos últimos 7 dias; pedidos de guia atualizada sem resposta */
    pagamentosComComprovante: z.number().int().optional(), atualizadasPedidas: z.number().int().optional(),
    /** fatia 2c: envios que esperam a mensagem do WhatsApp */ whatsappPendentes: z.number().int().optional() }),
});
export type Digest = z.infer<typeof Digest>;
